module.exports = __webpack_public_path__ + "static/media/ss5_preview.53c85107.jpg";